// Auto-generated from proto definitions. DO NOT EDIT.

export type NotificationPriority = 'NOTIFICATION_PRIORITY_UNSPECIFIED' | 'NOTIFICATION_PRIORITY_LOW' | 'NOTIFICATION_PRIORITY_NORMAL' | 'NOTIFICATION_PRIORITY_HIGH' | 'NOTIFICATION_PRIORITY_URGENT';

export const NotificationPriorityValues = ['NOTIFICATION_PRIORITY_UNSPECIFIED', 'NOTIFICATION_PRIORITY_LOW', 'NOTIFICATION_PRIORITY_NORMAL', 'NOTIFICATION_PRIORITY_HIGH', 'NOTIFICATION_PRIORITY_URGENT'] as const;
